const fieldsA = [
  'PDB_Installation_durchgefuehrt_durch',
  'PDB_Ladestationen_Instalateur',
  'UE_Zusatzinfos_AnschulssTyp',
  'PDB_Netzanschluss',
  'PDB_NA_P_Vollmacht_Netzbetreiber_abgelegt',
  'PDB_NA_P_Link_Vollmacht_Netzbetreiber',
  'PDB_NA_P_Netzanschlussvertrag_Liegenschaft_abgelegt',
  'PDB_NA_P_Link_NAV_Liegenschaft',
  'PDB_NA_P_Anforderungen_aus_NAV',
  'PDB_NA_P_Genehmigung_Ladeinfrastruktur_abgelegt',
  'PDB_NA_P_Link_Baurechtliche_Genehmigung_LIS',
  'PDB_NA_P_Anforderungen_Auflagen_Baurecht',
  'PDB_Netzform',
  'PDB_LISNutzbareLeistung',
  'PDB_Kundenanschluss',
  'PDB_SeperateEVUZahlung',
  'PDB_SeperateEVUZahlung_realisierbar',
  'PDB_Netzdienliche_Steuerung',
  'PDB_LSProdArtNr',
  'PDB_LSSerialNr',
  'PDB_Eichrechtskonform',
  'PDB_LadepunkteTyp',
  'PDB_IimLademanagement_InternesLademanagement',
  'PDB_Versanddatum',
  'PDB_UdpAktive',
  'PDB_RFIDKartennummer',
  'PDB_ZusaetzlicheAnschlussinformationen',
  'PDB_AusbauGewuenscht',
  'PDB_GeplanteFertisgtellung',
  'PDB_GeplanteInstalation',
]
const keyA = 'Anschlussinformationen_a'

const fieldsAC = [
  'UE_Ladestationen_TypLadestationAC',
  'UE_Ladestationen_AnzahlLadepunkteAC',
  'UE_Ladestationen_LadeleistungJeLadepunktAC',
  'UE_Ladestationen_AnzahlLadestationenAC',
  'UE_Ladestationen_AnzahlStellplaetzeAC',
]
const keyAC = 'Anschlussinformationen_AC-Ladestationen'

const fieldsDC = [
  'UE_Ladestationen_TypLadestationDC',
  'UE_Ladestationen_AnzahlLadepunkteDC',
  'UE_Ladestationen_LadeleistungJeLadepunktDC',
  'UE_Ladestationen_AnzahlLadestationenDC',
  'UE_Ladestationen_AnzahlStellplaetzeDC',
]
const keyDC = 'Anschlussinformationen_DC-Ladestationen'

const fieldsB = [
  'UE_Ladestationen_GesamtleistungMoreThen11kW',
  'UE_Ladestationen_Gesamtleistung',
  'UE_Ladestationen_Gesamtl_beantragt', // beantragte Gesamtleistung insg. in kW
  'UE_Ladestationen_Gesamtl_genehmigt', // genehmigte Gesamtleistung insg. in kW
  'PDB_FirmenlogoAufDisplay',
  'PDB_FirmenlogoLink',
  'PDB_AnmeldungBeiNetzbetreiber',
  'PDB_GenehmigungNetzbetreiber',
  'PDB_Kundenwuensche_allgemein',
  'PDB_DatumGenehmigung_Anmeldung',
]
const keyB = 'Anschlussinformationen_b'

export const fieldOrderAnschlussinformationen = {
  [keyA]: { fields: fieldsA },
  [keyAC]: { fields: fieldsAC },
  [keyDC]: { fields: fieldsDC },
  [keyB]: { fields: fieldsB },
}

const key = 'Anschlussinformationen'
export const formGroupAnschlussinformationen = {
  key,
  title: key,
  forms: [
    { key: keyA, form: keyA },
    { key: keyAC, title: keyAC, form: keyAC },
    { key: keyDC, title: keyDC, form: keyDC },
    { key: keyB, form: keyB },
  ],
}
